import { FractalSDKError } from "./base.js";
export class FractalSDKApprovalDeniedError extends FractalSDKError {
    constructor(message) {
        super(message);
        this.name = 'FractalSDKApprovalDeniedError';
        Object.setPrototypeOf(this, FractalSDKApprovalDeniedError.prototype);
    }
    getUserFacingErrorMessage() {
        return 'The user denied the project access to their information';
    }
}
export class FractalSDKApprovalOccurringError extends FractalSDKError {
    constructor(message) {
        super(message);
        this.name = 'FractalSDKApprovalOccurringError';
        Object.setPrototypeOf(this, FractalSDKApprovalOccurringError.prototype);
    }
    getUserFacingErrorMessage() {
        return 'Please complete the pending request to approve or deny the transaction.';
    }
}
//# sourceMappingURL=approve.js.map